import * as Yup from 'yup';

export const firstNameValidation = Yup.string()
  .matches(/^[A-Za-z\s]+$/, "First Name can only contain letters")
  .min(2, "First Name must be at least 2 characters long")
  .max(50, "First Name cannot be longer than 50 characters")
  .required("First Name is required");

export const lastNameValidation = Yup.string()
  .matches(/^[A-Za-z\s]+$/, "Last Name can only contain letters")
  .max(50, "Last Name cannot be longer than 50 characters")
  .required("Last Name is required");

const PHONE_MIN_DIGITS_MESSAGE = "Phone number must be at least 10 digits";

function phoneHasAtLeastTenDigits(value?: string | null) {
  return String(value || "").replace(/\D/g, "").length >= 10;
}

export const phoneValidation = Yup.string()
  .required("Phone number is required")
  .test("min-phone-digits", PHONE_MIN_DIGITS_MESSAGE, (value) => phoneHasAtLeastTenDigits(value));

export const phone2Validation = Yup.string().test(
  "min-phone-digits",
  PHONE_MIN_DIGITS_MESSAGE,
  (value) => {
    const raw = String(value || "").trim();
    if (!raw) return true;
    return phoneHasAtLeastTenDigits(raw);
  }
);

export const emailValidation = Yup.string()
  .email("Invalid email address")
  .required("Email is required");

export const jobTitleValidation = Yup.string()
  .required("Role is required");

export const statusValidation = Yup.string()
  .required("Status is required");

export const permissionsValidation = Yup.array()
  .of(Yup.string().required("Permission is required"))
  .min(1, "At least one permission must be selected")
  .required("Permissions are required");

export const assignedWarehousesValidation = Yup.array().of(
  Yup.object({
    id: Yup.string().required("Warehouse ID is required"),
    label: Yup.string().required("Warehouse label is required"),
  })
).min(1, "At least one warehouse must be assigned")
  .required("Assign Warehouses is required");

export const assignedWarehousesValidations = Yup.array()
  .of(
    Yup.object({
      _id: Yup.string().required("Warehouse ID is required"),
      label: Yup.string().required("Warehouse label is required"),
    }).noUnknown(true) // Ignores extra fields
  )
  .min(1, "At least one warehouse must be assigned")
  .required("Assign Warehouses is required");



export const passwordValidation = Yup.string()
  .matches(
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
    "Password must be at least 8 characters long, include one uppercase letter, one number, and one special character"
  )
  .required("Password is required");

export const assignedOfficesValidation = Yup.array()
  .of(Yup.string().required("Office is required"))
  .min(1, "At least one office must be assigned")
  .required("Assign Offices is required");

export const addressLine1Validation = Yup.string()
  .min(2, "Address Line 1 must be at least 2 characters long")
  .max(50, "Address Line 1 cannot be longer than 50 characters")
  .required("Address Line 1 is required");

export const cityValidation = Yup.string()
  .min(2, "City must be at least 2 characters long")
  .max(50, "City cannot be longer than 50 characters")
  .required("City is required");

export const stateValidation = Yup.string()
  .min(2, "State must be at least 2 characters long")
  .max(50, "State cannot be longer than 50 characters")
  .required("State is required");

export const zipcodeValidation = Yup.string().required("Zipcode is required");

export const countryValidation = Yup.string()
  .min(2, 'Country must be at least 2 characters long')
  .max(50, 'Country cannot be longer than 50 characters')
  .required("Country is required");

export const companyNameValidation = Yup.string()
  .min(2, "Company name must be at least 2 characters long")
  // .max(50, "Company name cannot be longer than 50 characters")
  .required("Company name is required");

export const officeNameValidation = Yup.string()
  .min(2, "Office name must be at least 2 characters long")
  .max(50, "Office name cannot be longer than 50 characters")
  .required("Office Name is required");

export const warehouseNameValidation = Yup.string()
  .min(2, 'Warehouse name must be at least 2 characters long')
  .max(50, 'Warehouse name cannot be longer than 50 characters')
  .required('Warehouse Name is required');

export const labelOfAddressValidation = Yup.string()
  .required('Label of address is required');

export const quantityValidation = Yup.number()
  .typeError('Quantity must be a number')
  .min(1, 'Quantity must be at least 1')
  .required('Quantity is required');

export const nameValidation = Yup.string()
  .min(2, "Name must be at least 2 characters long")
  // .max(50, "Name cannot be longer than 50 characters")
  .required("Name is required");

export const imageValidation = Yup.mixed().test(
  "fileType",
  "Unsupported file format",
  (value) =>
    !value || // allow empty
    (value instanceof File &&
      ["image/jpeg", "image/png", "image/jpg"].includes(value.type))
);

export const scheduledDate = Yup.string().required("Scheduled date is required")
export const removalDate = Yup.string().required("removal date is required")
export const orderNumber = Yup.string().required("Order Number date is required")

export const priority = Yup.number()
  .nullable()
  .required("Priority is required")